import { render, staticRenderFns } from "./IdManagerOverview.vue?vue&type=template&id=8d04ca66&scoped=true&"
import script from "./IdManagerOverview.vue?vue&type=script&lang=js&"
export * from "./IdManagerOverview.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerOverview.vue?vue&type=style&index=0&id=8d04ca66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d04ca66",
  null
  
)

export default component.exports